import { Component, computed, effect, inject, input, ViewContainerRef } from '@angular/core';
import { ButtonDirective, CuiDialogService } from '@innersource/common-ui-components';
import { ChatAttachmentsService } from '../chat-attachments.service';
import { ChatAttachment } from '../chat.model';
import { ChatAttachmentPreviewDialogComponent } from '../chat-attachment-preview-dialog/chat-attachment-preview-dialog.component';

/** Displays a file preview tile with an optional draft removal control. */
@Component({
  selector: 'app-chat-attachment-tile',
  imports: [ButtonDirective],
  templateUrl: './chat-attachment-tile.component.html',
  styleUrl: './chat-attachment-tile.component.scss',
})
export class ChatAttachmentTileComponent {
  /** Inputs. */
  readonly file = input.required<ChatAttachment>();
  readonly removable = input(false);

  /** Services. */
  readonly attachments = inject(ChatAttachmentsService);
  private readonly dialog = inject(CuiDialogService);
  private readonly viewContainerRef = inject(ViewContainerRef);

  /** Returns the thumbnail when an image is available. */
  readonly previewUrl = computed(() => this.attachments.previewUrl(this.file()));

  /** Loads image previews when the tile receives a file. */
  constructor() {
    // The service caches object URLs across draft and sent renderings of the same file.
    effect(() => {
      void this.attachments.loadPreview(this.file());
    });
  }

  /** Opens a larger preview with a download action. */
  openPreview(): void {
    const file = this.file();
    this.dialog.open(ChatAttachmentPreviewDialogComponent, {
      ariaLabel: `Preview ${file.name}`,
      data: file,
      size: 'big',
      width: 'min(80rem, calc(100vw - 3rem))',
      maxWidth: 'calc(100vw - 3rem)',
      viewContainerRef: this.viewContainerRef,
    });
  }
}
